module.exports = __webpack_public_path__ + "fonts/montserrat-medium-webfont.a20f011.woff";